import { render, staticRenderFns } from "./PacmanLoader.vue?vue&type=template&id=02a59b7b&"
import script from "./PacmanLoader.vue?vue&type=script&lang=js&"
export * from "./PacmanLoader.vue?vue&type=script&lang=js&"
import style0 from "./PacmanLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports